/**
 * Região do Gerador (GEN) no aerogerador.
 */
const GEN = "GEN";

/**
 * Região do Low-Speed Shaft (LSS) no aerogerador.
 */
const LSS = "LSS";

/**
 * Região do High-Speed Shaft (HSS) no aerogerador.
 */
const HSS = "HSS";

/**
 * Região do Intermediate Shaft (IMS) no aerogerador.
 */
const IMS = "IMS";

export default {
	GEN, LSS, HSS, IMS
};